import axios from 'axios';
import { getAuthToken } from './localStorage';

// create an axios instance
const service = axios.create({
    baseURL: import.meta.REACT_APP_API_URL || process.env.REACT_APP_API_URL || '/api', // url = base url + request url
    // withCredentials: false, // send cookies when cross-domain requests
    timeout: 15000 // request timeout,
});

// request interceptor
service.interceptors.request.use(
    config => {
        const token = getAuthToken();
        if (token) config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    error => {
    // do something with request error
        console.warn('[axios][service.interceptors.request] error: ', error);
        return Promise.reject(error);
    }
);

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data;
        if (res.errorCode) {
            const message = res.errorMessage ? res.errorMessage : 'Unknown error';
            return Promise.reject(new Error(message));
        }
        return res.data;
    },
    error => {
        const { response } = error;
        console.warn('[axios][service.interceptors.response] err:', error, response);
        // const message = response && response.data && response.data.errorMessage ? response.data.errorMessage : error.message;
        const message = response?.data?.errorMessage || response?.data?.message?.[0]?.error || response?.data?.message || error?.message;
        return Promise.reject(new Error(message));
    }
);

export default service;
